module.exports = __webpack_public_path__ + "img/img01.c4c80da2.png";